module.exports = __webpack_public_path__ + "static/media/biurka_gdansk.52748592.png";